"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeOfficeBootstrap = void 0;
var tslib_1 = require("tslib");
var mobx_1 = tslib_1.__importDefault(require("mobx"));
var theme_1 = require("./components/theme");
var services_1 = require("./services");
var page_state_1 = require("./state/page.state");
var store_1 = require("./store");
exports.IkeOfficeBootstrap = {
    initBasic: function ($window) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        services_1.Services.Window.setWindow($window);
                        $window.document.addEventListener('DOMContentLoaded', function () {
                            (0, theme_1.attachSheet)();
                            var waitForGoogleMaps = $window.setInterval(function () {
                                if (typeof google === 'undefined') {
                                    return;
                                }
                                $window.clearTimeout(waitForGoogleMaps);
                                page_state_1.CurrentState.setGoogleMapsLoaded();
                            }, 50);
                        });
                        return [4 /*yield*/, services_1.Services.bindServices()];
                    case 1:
                        _a.sent();
                        services_1.Services.Route.bindRoutes();
                        if (!services_1.Services.User.hasUser) {
                            services_1.Services.Route.tokensLoaded = true;
                            services_1.Services.Route.profilesLoaded = true;
                            services_1.Services.Route.firstLoad();
                        }
                        $window['Ike'] = {
                            AppStore: store_1.AppStore,
                            Services: services_1.Services,
                            State: page_state_1.CurrentState,
                            mobx: mobx_1.default
                        };
                        return [2 /*return*/];
                }
            });
        });
    },
    init: function ($window) {
        exports.IkeOfficeBootstrap.initBasic($window);
    }
};
//# sourceMappingURL=bootstrap.js.map